export default __webpack_public_path__ + "static/media/sms.2a300e9e.svg";